import { render, staticRenderFns } from "./CategoryReturnsReport.vue?vue&type=template&id=f98a3064&"
import script from "./CategoryReturnsReport.vue?vue&type=script&lang=js&"
export * from "./CategoryReturnsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports